import {axiosInstance as mantis} from "./mantis";

export const getTenantDetails = (tenantId) => {
    return mantis.get("/tenant/" + tenantId);
};

export const getTenantSubTenantList = (tenantId, query, type, page, limit, sortBy, sortDir) => {
    const params = {
        parentTenantId: tenantId,
        name: query.name,
        description: query.description,
        type: type,
        pageNumber: page + 1,
        pageSize: limit,
        sortBy: sortBy,
        sortDirection: sortDir
    };
    const config = {params: params};
    return mantis.get("/tenant/", config);
};

export const getTenantUserList = (tenantId, query, role, page, limit, sortBy, sortDir) => {
    const params = {
        parentTenantId: tenantId,
        username: query.username,
        email: query.email,
        role: role,
        pageNumber: page + 1,
        pageSize: limit,
        sortBy: sortBy,
        sortDirection: sortDir
    };
    const config = {params: params};
    return mantis.get("/user/", config);
};

export const getTenantOrderList = (tenantId, query, productCode, status, page, limit, sortBy, sortDir) => {
    const params = {
        parentTenantId: tenantId,
        commonName: query.commonName,
        providerOrderId: query.providerOrderId,
        partnerId: query.partnerId,
        productCode: productCode,
        status: status,
        tenantName: query.tenantName,
        pageNumber: page + 1,
        pageSize: limit,
        sortBy: sortBy,
        sortDirection: sortDir
    };

    const config = {params: params};
    return mantis.get("/order/", config);
};
export const createTenant = (tenantId, name, description, type) => {
    const data = {
        parentTenantId: tenantId,
        name: name,
        description: description,
        type: type
    };
    return mantis.post("/tenant/", data);
};

export const editTenant = (tenantId, name, description, type) => {
    const data = {
        name: name,
        description: description,
        type: type
    };
    return mantis.put(`/tenant/${tenantId}`, data);
};

export const deleteTenant = tenantId => {
    return mantis.delete(`/tenant/${tenantId}`);
};
